import React from "react";
import { useSelector } from "react-redux";

import PromotionImg from "../../../assets/images/promotion/promotion1.jpg";
import PromotionImg2 from "../../../assets/images/promotion/promotion2.jpg";
import PromotionImg3 from "../../../assets/images/promotion/promotion3.jpg";
import PromotionImg4 from "../../../assets/images/promotion/promotion4.jpg";
import ComingSoon from "../../../assets/images/promotion/comingsson.jpg";

export const Promotion = () => {
  const { appDetails } = useSelector((state) => state.app);

  return (
    <>
      <main className="main">
        <div className="container">
          <div className="PromotionSection">
            <div className="PromtoionHeader">
              <h1>Promotion</h1>
            </div>
            {/* <div className="PromtoionImg">
              <ul>
                <li>
                  <img src={PromotionImg} alt="PromotionImg" />
                </li>
                <li>
                  <img src={PromotionImg2} alt="PromotionImg" />
                </li>
                <li>
                  <img src={PromotionImg3} alt="PromotionImg" />
                </li>
                <li>
                  <img src={PromotionImg4} alt="PromotionImg" />
                </li>
              </ul>
            </div> */}
            <div className="comingsoon mt-3 mb-3">
              <img src={ComingSoon} alt="ComingSoon" />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Promotion;
